import React from 'react';

import FieldReportListScreen, { FieldReportListConfig } from 'src/screen/Protected/FieldReportListScreen/FieldReportListScreen';
import { AUDIT_TYPES } from 'src/screen/Protected/FieldReportListScreen/fieldReportTypes';

const CONFIG: FieldReportListConfig = {
  category: 'audit',
  types: AUDIT_TYPES,
  titleKey: 'nav.audits',
  createDialogTitleKey: 'audits.selectType',
  // Audits carry no pass/fail verdict, so the status column and its filter are dropped here.
  showStatus: false,
  tableId: 'audits-table',
  rootId: 'audits-screen',
  columnWidths: {
    withSelect: ['5%', '20%', '26%', '20%', '20%', '9%'],
    withoutSelect: ['25%', '30%', '20%', '25%'],
  },
};

export default function AuditsScreen () {
  return <FieldReportListScreen config={CONFIG} />;
}
